import { render } from "./PasswordReset.vue?vue&type=template&id=0d1d7258&scoped=true&ts=true"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"

import "./PasswordReset.vue?vue&type=style&index=0&id=0d1d7258&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1d7258"]])

export default __exports__